import 'aos/dist/aos.css'
/* import '@/assets/css/index.css' */

import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import VSwitch from 'v-switch-case'
import AOS from 'aos'
import 'tw-elements';

import VueTelInput from 'vue-tel-input';
import 'vue-tel-input/dist/vue-tel-input.css';

import CountryFlag from 'vue-country-flag'

import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

import VueMasonry from 'vue-masonry-css'

Vue.use(VueMasonry);

library.add(
  faCalendar,
  faUser
)

Vue.component('font-awesome-icon', FontAwesomeIcon)
Vue.component('country-flag', CountryFlag)

import "@/plugins/mixins";
import "@/plugins/components";
const moment = require('moment')

import vuetify from './plugins/vuetify'

import { library } from '@fortawesome/fontawesome-svg-core'
import {
  faCalendar,
  faUser
} from '@fortawesome/free-solid-svg-icons'

/* MODULI */
import { registerModules } from "./register-modules";

import user from "./modules/user";
import work from "./modules/work";
import proposals from "./modules/proposals";
registerModules({
  user: user,
  work: work,
  proposals: proposals,
});

import Toast from "vue-toastification";
import "vue-toastification/dist/index.css";

/* MAPS */
import * as VueGoogleMaps from "vue2-google-maps"

Vue.use(VueGoogleMaps, {
  load: {
    key: "AIzaSyAAMqPSvSi793RJ8EgttnFoZ_cR1_jeGkk",
    libraries: "places,drawing,geometry"
  }
});

// import { VueReCaptcha } from 'vue-recaptcha-v3'
// Vue.use(VueReCaptcha, { siteKey: '6LefxscnAAAAANx6iMzPr5M1WcE9lADqbwp65TrL' })

/* TOAST */
Vue.use(Toast, {
  transition: "Vue-Toastification__fade",
  position: "top-right",
  timeout: 10000,
  closeOnClick: false,
  pauseOnFocusLoss: true,
  pauseOnHover: true,
  draggable: false,
  showCloseButtonOnHover: false,
  hideProgressBar: false,
  closeButton: "button",
  icon: true,
  rtl: false,
  maxToasts: 20,
  newestOnTop: true
});

Vue.config.productionTip = false;

Vue.use(VSwitch)
Vue.use(VueTelInput);

require('moment/locale/es')
moment.locale('it');
 
Vue.use(require('vue-moment'), {
    moment
})

import VueI18n from 'vue-i18n'

function loadLocaleMessages() {
  const locales = require.context('@/locales', true, /[A-Za-z0-9-_,\s]+\.json$/i);
  const messages = {};
  locales.keys().forEach((key) => {
    const matched = key.match(/([A-Za-z0-9-_]+)\./i);
    if (matched && matched.length > 1) {
        const matched = key.match(/([A-Za-z0-9-_]+)\//i);
        const matchedModule = key.match(/([A-Za-z0-9-_]+)\./i);
        if (matched && matched.length > 1 && matched && matchedModule.length > 1) {
            const locale = matched[1];
            messages[locale] = locales(key);
            const module = matchedModule[1];
            if (!messages[locale]) messages[locale] = {};
            messages[locale][module] = locales(key);
        }
    }
  });
  return messages;
}

Vue.use(VueI18n);
// must be called after vue.use
const i18n = new VueI18n({
    locale: "it",
    fallbackLocale: "it",
    messages: loadLocaleMessages(),
});

new Vue({
  i18n,
  components: {
    // ValidationProvider
  },
  router,
  store,
  vuetify,
  mounted() {
    AOS.init()
  },
  render: h => h(App)
}).$mount("#app");


